export default __webpack_public_path__ + "static/media/photoshopback.c54c6ae1.svg";